<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import { kydkpz_queryCompanyList,kydkpz_query } from "../../../../../api/kydkpz.js";
import config from "../../../../../../configHttp.js";
import {MainFunction} from "@/components/util/Function/MainFunction";
export default {
  data: function () {
    return {
      options: [],
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData:[],
      shaidiag: false,
      searchdiag: false,
      // 日期控件初始化时间
	  sjiangongsdata:{    
		  suosq: MainFunction.$getdefultMonth(),
		  companyNo: "",
		  },
      // 导出传参类型
      outputData: getdata().outputData,
      // 全部导出
      exportType: "1",
      tablekey: 0,
    };
  },
  
  methods: {
  currStationChange(v){
	  this.sjiangongsdata.companyNo=v
	  this.fetchResultShow();
  },
sbqjchange(){
	this.fetchResultShow();
	
},
    // 查询进行发票合计结果(分页)
    fetchResultShow() {
      kydkpz_query(this.sjiangongsdata).then(res => {
      	this.tableData = res.data.data
      	
      })
    },
chaxungongshihesju(){
	kydkpz_queryCompanyList().then(res => {
      	if(res.data.msg=="操作成功"){
			this.options=res.data.data.map(v=>{
				return {
					value:v.companyNo,
					label:v.nsrmc,
				}
			})
			this.sjiangongsdata.companyNo=this.options[0].value
			this.fetchResultShow();
		}else{
			  this.$message.error(res.data.msg);
		}
      })
	
},
    // 导出进项发票合计结果
    outPutIInvResult() {
      let selectVal = this.$refs.tablebox.getSelectionval();
	  this.sjiangongsdata.types=selectVal.map(v=>v.code).join(",")
      let params = {
        downUrl: config.baseURL + "kydk/list/export",
        typeObj: {
          toForm: false,
          fileName: "客运抵扣结果展示" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: this.sjiangongsdata
      };
	     this.$downloadcommon(params);
    },
  },
  components: {},
  created() {
    this.chaxungongshihesju();
  },
  mounted() {},
  computed: {
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
